import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import { getListAPI as getCampaignList } from 'components/campaign/CampaignAPI';
import { setCampaignList, setCampaignDashboardCampaignList } from 'store/slice/ManufSlice';
import CampaignDashboard from '../CampaignDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function CampaignPageImpl() {
    const dispatch = useDispatch();
    const { campaignList} = useSelector((state)=>state.manufslice);
    
    const getCampaignListSuccess = (list) =>{dispatch(setCampaignList(list));}
    useEffect(() => {
        getCampaignList(()=>{}, getCampaignListSuccess);
    },[]);
    useEffect(()=>{
        dispatch(setCampaignDashboardCampaignList( campaignList));
    },[ campaignList])

    return (
        < CampaignDashboard />
    )

}